// extracted by mini-css-extract-plugin
export default {"main":"styles_main__ATjyu","switcherContainer":"styles_switcherContainer__FnwX3","switcherContent":"styles_switcherContent__JRmYd","liquid":"styles_liquid__cqIsj"};